export const userSelector = state => state.app.user;
export const fahrzeugkostenSelector = state => state.app.fahrzeugkosten;
export const IndicatorSelector = state => state.app.indicator;
